import styled from "styled-components";

import { BREAKPOINT, paragraphStyles } from "../../constants/Styles";
import {
  header1Styles,
  header2Styles,
  header3Styles,
  listItemStyles,
  spanStyles,
  subHeaderStyles,
} from "../FlashPCBMarkdown/FlashPCBMarkdownStyles";

const Container = styled.div`
  max-width: ${BREAKPOINT};
  padding: 1rem;

  > a {
    ${spanStyles};
  }
`;

const Privacy = styled.div`
  h1 {
    ${header1Styles};
    text-align: center;
  }
  h2 {
    ${header2Styles};
  }
  h3 {
    ${header3Styles};
  }
  h4 {
    ${subHeaderStyles};
  }
  li {
    margin-left: 1rem;
    margin-bottom: 0.25rem;
    ${listItemStyles};
  }
  p {
    ${paragraphStyles};
  }
`;

export { Container, Privacy };
